const LazyDirective = {
  mounted(el: any, binding: any, vnode: any) {
    el.proxy = new Image();
    el.proxy.src = el.src;
    el.proxy.onload = (e: any) => {
      el.src = el.proxy.src;
    };

    el.src = binding.value;
  },

  unmounted(el: any) {
    delete el.proxy;
  },
};
(LazyDirective as any).install = function (app) {
  app.directive("lazy", LazyDirective);
};
export default LazyDirective;
